import React from 'react';
import OrderLineItemCard from './OrderLineItemCard';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

export default function OrderLineItemsList({ order, className }) {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'Components:AlertScreens:Shared:OrderLineItem:OrderLineItemsList',
  });

  return (
    <div className={classnames('space-y-sm', className)}>
      <h6 className="text-base">{t('title')}:</h6>
      {order.line_items.map((item) => (
        <OrderLineItemCard data={item} key={`line-item-${item.id}`} />
      ))}
    </div>
  );
}
